import { LOCALE_DEFAULT } from '@growtherapy/i18n';

import { NS_TELEHEALTH_CORE } from './constants';
import telehealthCoreEn from './en/telehealth-core.json';
import { externalResources } from './externalResources';

const telehealthCoreResouces = {
  [NS_TELEHEALTH_CORE]: telehealthCoreEn,
  ...externalResources,
};

export const telehealthCoreResoucesEn = {
  [LOCALE_DEFAULT]: telehealthCoreResouces,
};
